/* import __COLOCATED_TEMPLATE__ from './date-and-time-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();